/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagerAssignPostGroupResponse } from "./MemberManagerAssignPostGroupResponse";

export type MemberManagerAssignPostGroupResponseApiRespoonse = {
  data?: MemberManagerAssignPostGroupResponse;
  status?: MemberManagerAssignPostGroupResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MemberManagerAssignPostGroupResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
